import ProductDelete from "./product-delete-button";

export default ProductDelete;